module.exports = __webpack_public_path__ + "img/p1-info.7b63f22a.jpg";